import { roundoffAmount } from "./roundoffAmount";

export const calculateSalaryBreakdown = (salary, config) => {
  console.log(config);

  const result = {
    basic: 0,
    hra: 0,
    medicalAllowance: 0,
    statutoryBonus: 0,
    pfContribution: 0,
    gratuity: 0,
    specialAllowance: 0,
    mobileInternetAllowance: 0,
    medicalInsurance: 0,
    otherAllowance: 0,
    totalPay: 0,
  };

  // Only calculate if percentage is not null and not zero
  if (config.basic_percentage && parseFloat(config.basic_percentage) > 0) {
    const basic = salary * (parseFloat(config.basic_percentage) / 100);
    result.basic = basic.toFixed(1);

    // HRA calculation depends on basic
    if (config.hra_percentage && parseFloat(config.hra_percentage) > 0) {
      result.hra = (basic * (parseFloat(config.hra_percentage) / 100)).toFixed(
        1
      );
    }

    // Medical allowance calculation depends on basic
    if (
      config.medical_allowance_percentage &&
      parseFloat(config.medical_allowance_percentage) > 0
    ) {
      result.medicalAllowance = (
        basic *
        (parseFloat(config.medical_allowance_percentage) / 100)
      ).toFixed(1);
    }

    // Statutory bonus calculation depends on basic
    if (
      config.statutory_bonus_percentage &&
      parseFloat(config.statutory_bonus_percentage) > 0
    ) {
      result.statutoryBonus = (
        basic *
        (parseFloat(config.statutory_bonus_percentage) / 100)
      ).toFixed(1);
    }

    // PF contribution calculation depends on basic
    if (
      config.pf_contribution_percentage &&
      parseFloat(config.pf_contribution_percentage) > 0
    ) {
      result.pfContribution = roundoffAmount(
        basic * (parseFloat(config.pf_contribution_percentage) / 100)
      );
    }

    // Gratuity calculation depends on basic
    if (
      config.gratuity_percentage &&
      parseFloat(config.gratuity_percentage) > 0
    ) {
      result.gratuity = roundoffAmount(
        basic * (parseFloat(config.gratuity_percentage) / 100)
      );
    }

    // Special allowance calculation depends on basic
    if (config.special_allowance && parseFloat(config.special_allowance) > 0) {
      result.specialAllowance =
        basic * (parseFloat(config.special_allowance) / 100);
    }
  }

  // Fixed allowances - set to 0 if null or not greater than 0
  if (
    config.mobile_internet_allowance &&
    parseFloat(config.mobile_internet_allowance) > 0
  ) {
    result.mobileInternetAllowance = parseFloat(config.mobile_internet_allowance);
  }

  if (config.medical_insurance && parseFloat(config.medical_insurance) > 0) {
    result.medicalInsurance = parseFloat(config.medical_insurance);
  }

  // Calculate other allowance and total pay
  const calculatedComponents =
    (parseFloat(result.basic) || 0) +
    (parseFloat(result.hra) || 0) +
    (parseFloat(result.medicalAllowance) || 0) +
    (parseFloat(result.statutoryBonus) || 0) +
    (parseFloat(result.specialAllowance) || 0) +
    (parseFloat(result.mobileInternetAllowance) || 0) +
    (parseFloat(result.medicalInsurance) || 0);

  const otherAllowance = salary - calculatedComponents;
  if (otherAllowance > 0) {
    result.otherAllowance = otherAllowance.toFixed(1);
  }

  result.totalPay = roundoffAmount(salary);

  return result;
};
